/**
 * シーズン選択コンポーネント
 */
export default class SeasonSelector {
  /**
   * Public: コンストラクタ
   *
   * options - 以下のようなプロパティを持つオブジェクト。
   *           yearSelectId   - 西暦セレクトボックスのID。
   *           seasonSelectId - シーズンセレクトボックスのID。
   */
  constructor(options) {
    this.options = options;
  }

  init() {
    this.yearSelector = document.getElementById(this.options.yearSelectId);
    this.seasonSelector = document.getElementById(this.options.seasonSelectId);

    this.yearSelector.addEventListener("change", this.handleChange.bind(this));
    this.seasonSelector.addEventListener(
      "change",
      this.handleChange.bind(this),
    );
  }

  handleChange() {
    const year = this.yearSelector.value;
    const season = this.seasonSelector.value;
    window.location.pathname = `/titles/year/${year}/${season}`;
  }
}
